import { Observable } from 'rxjs';
import { stringify } from 'query-string';
import { Injectable } from '@angular/core';

import { ApiModel } from './api.model';

@Injectable()
export class OrderRightsModel {
    constructor(private apiModel: ApiModel) {}

    public getAllocatedStorages(
        brandId: string,
        retailerGroupId: string,
        storageIds: string[]
    ): Observable<
        {
            _id: string;
        }[]
    > {
        const queryParams = { storageIds };
        const query = stringify(queryParams, { arrayFormat: 'bracket', sort: false });
        return this.apiModel.makeHttpObservableRequest({
            url: `${this.apiModel.getBrandsEndpoint()}/${brandId}/retailer-groups/${retailerGroupId}/storages?${query}`,
            method: 'get'
        });
    }

    public setAllocatedStorages(
        brandId: string,
        retailerGroupId: string,
        grandAccessStorageIds: string[],
        revokeAccessStorageIds: string[]
    ): Observable<
        {
            _id: string;
        }[]
    > {
        const body = {
            addedStorages: grandAccessStorageIds,
            removedStorages: revokeAccessStorageIds
        };
        return this.apiModel.makeHttpObservableRequest({
            url: `${this.apiModel.getBrandsEndpoint()}/${brandId}/retailer-groups/${retailerGroupId}/storages`,
            method: 'post',
            body
        });
    }
}
